/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable import/order */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  formatCurrency,
  formatDate,
  getNewDate,
  isAfterDate,
  isEmpty,
  scrollToTop,
  getEligibilityForPaymentMode,
} from '../../shared/helper-utils/appUtils';
import { getInsuranceInfo, getUserDetails } from '../../api/profileApi';
import {
  getUserAgentId,
  getObjectFromLS,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import {
  emailFlightOptions,
  getFlightTicketApi,
  getPaymentGateway,
} from '../../api/flightApi';
import { addDays, differenceInCalendarDays, differenceInYears } from 'date-fns';
import {
  API_DATE_FORMAT,
  DATE_MONTH_YEAR_WITH_HYPHEN,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppButton from '../../shared/components/app-button/AppButton';
import { Card, Col, Row } from 'react-bootstrap';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppLink from '../../shared/components/app-link/AppLink';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppModal from '../../shared/components/app-modal/AppModal';
import {
  getTboInsurancePlans,
  issueTboInsuranceApi,
} from '../../api/tboInsuranceApi';
import './InsurancePage.scss';
import {
  COUNTRY_OPTIONS,
  COUNTRY_OPTIONS_THREE_CHARS,
} from '../../shared/constants/CountryOptions';
import { NET_BANKING_OPTIONS_LIVE } from '../../shared/constants/NetBankingOptions';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { CiWallet, CiBank } from 'react-icons/ci';
import { MdOutlineCreditCard } from 'react-icons/md';

function TboInsurance() {
  const TITLE_OPTIONS = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Ms', value: 'Ms' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Mstr', value: 'Mstr' },
  ];
  const [planCovergaeOptions, setPlanCoverageOptions] = useState([
    { label: 'India', value: 4 },
    { label: 'US', value: 1 },
    { label: 'Non US', value: 2 },
    { label: 'WorldWide', value: 3 },
    { label: 'Asia', value: 5 },
    { label: 'Canada', value: 6 },
    { label: 'Australia', value: 7 },
    { label: 'Schenegen Countries', value: 8 },
  ]);
  const [selectedPlanCovergae, setSelectedPlanCoverage] = useState(4);
  const [domInt, setDomint] = useState('domestic');
  const [planType, setPlanType] = useState('oneway');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [planOptions, setPlanOptions] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanId, setSlectedPlanId] = useState('');
  const [selectedResultIndex, setSelectedResultIndex] = useState('');
  const [depDate, setDepDate] = useState(
    formatDate(getNewDate(TODAY_DATE), API_DATE_FORMAT),
  );
  const [toDate, setToDate] = useState(
    formatDate(getNewDate(TODAY_DATE), API_DATE_FORMAT),
  );
  const [arrDate, setArrDate] = useState('');

  const [numPax, setNumPax] = useState(1);
  const [txId, setTxId] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [checkoutPgCharge, setcheckoutPgCharge] = useState(0);
  const [checkoutgstPgCharge, setgstcheckoutPgCharge] = useState(0);
  const [checkoutInvTotal, setcheckoutInvTotal] = useState(0);
  const [paxDetails, setPaxDetails] = useState([
    {
      title: '',
      firstname: '',
      lastname: '',
      beneficiarytitle: '',
      beneficiaryname: '',
      beneficiaryfirstname: '',
      beneficiarylastname: '',
      relationshiptoinsured: 'self',
      relationtobeneficiary: '',
      addressline1: '',
      addressline2: '',
      citycode: '',
      emailid: '',
      phonenumber: '',
      countrycode: '',
      majordestination: '',
      passportcountry: '',
      passportno: '',
      pincode: '',
      age: '',
      dob: '',
    },
  ]);
  const [paymentmode, setPaymentMode] = useState('cashcard');
  const [selectedPg, setSelectedPg] = useState('');
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [showFooter, setShowFooter] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [planBenifits, setPlanBenifits] = useState([]);
  const [showBenifitsPopup, setShowBenifitsPopup] = useState(false);
  const [hasDetails, setHasDetails] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailToSent, setEmailToSent] = useState('');
  const [emailPlans, setEmailPlans] = useState([]);
  const [searchTab, setSearchTab] = useState(true);
  const [resultsTab, setResultsTab] = useState(false);
  const [detailsTab, setDetailsTab] = useState(false);
  const [reviewTab, setReviewTab] = useState(false);
  const [confTab, setConfTab] = useState(false);
  const [successTxId, setSuccessTxId] = useState('');
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [isBookingConfirmationDialogOpen, setBookingConfirmationDialogOpen] =
    useState(false);
  const selectedPaymentGatewayRef = useRef([]);
  const [PaymentGateway, setPaymentGateway] = useState(false);
  const [tempPgList, setTempPgList] = useState([]);
  const [selectedBankForNetBanking, setSelectedBankForNetBanking] =
    useState('');
  const [isPayuPgAccepted, setIsPayuPgAccepted] = useState(false);
  const [agent, setAgent] = useState({});
  const paxDropDown = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
  ];
  const relationDropDown = [
    { label: 'Brother', value: 'Brother' },
    { label: 'Child', value: 'Child' },
    { label: 'Employer', value: 'Employer' },
    { label: 'Father', value: 'Father' },
    { label: 'Legal Heir', value: 'Legal Heir' },
    { label: 'Mother', value: 'Mother' },
    { label: 'Sister', value: 'Sister' },
    { label: 'Spouse', value: 'Spouse' },
  ];
  const [selectedTab, setSelectedTab] = useState('search');
  const [showTerms, setShowTerms] = useState(true);
  const selectedPlanForbreakupRef = useRef(undefined);
  const [showBreakupModal, setShowBreakupModal] = useState(undefined);
  const selectedCoverageDetailsRef = useRef(undefined);
  const [numDays, setNumDays] = useState('');

  const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const checkMobileNumber = (phNumber) => {
    return (
      phNumber?.toString()?.trim() !== '' &&
      /^[5-9]\d{9}$/gi.test(phNumber) === false
    );
  };

  const checkEmailAddress = (email) => {
    return email !== '' && EMAIL_REGEX.test(email) === false;
  };

  const updatePaymentMode = (pmselected) => {
    setPaymentMode(pmselected);
    const pgForPmSelected = selectedPaymentGatewayRef.current.filter(
      (x) => x.PaymentMode.toLowerCase() === pmselected,
    );
    if (pgForPmSelected.length > 0) {
      setSelectedPg(pgForPmSelected[0].GatewayName);
    }
    setTempPgList(pgForPmSelected);
  };

  const handlePgSelection = (pgname) => {
    setSelectedPg(pgname);
    setIsPayuPgAccepted(false);
  };

  const handleCheckboxChange = (item) => {
    setEmailPlans((prevSelected) => {
      if (
        prevSelected.some(
          (selected) => selected.resultIndex === item.resultIndex,
        )
      ) {
        // Remove item if already selected
        return prevSelected.filter(
          (selected) => selected.resultIndex !== item.resultIndex,
        );
      } else {
        // Add item if not selected
        return [...prevSelected, item];
      }
    });
  };

  const handleSubmit = () => {
    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(selectedPlan) ||
        isEmpty(depDate) ||
        isEmpty(toDate) ||
        isEmpty(paxDetail.addressline1) ||
        isEmpty(paxDetail.addressline2) ||
        isEmpty(paxDetail.title) ||
        isEmpty(paxDetail.firstname) ||
        isEmpty(paxDetail.lastname) ||
        isEmpty(paxDetail.beneficiaryfirstname) ||
        isEmpty(paxDetail.beneficiarylastname) ||
        isEmpty(paxDetail.beneficiarytitle) ||
        isEmpty(paxDetail.citycode) ||
        isEmpty(paxDetail.majordestination) ||
        isEmpty(paxDetail.countrycode) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.phonenumber) ||
        isEmpty(paxDetail.emailid) ||
        isEmpty(paxDetail.relationtobeneficiary) ||
        isEmpty(paxDetail.dob)
      ) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
      if (domInt === 'international' && isEmpty(paxDetail.passportno)) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });
    setShowFooter(true);
  };

  const handleUpdatePaxDetails = (name, value, index) => {
    const list = [...paxDetails];
    list[index][name] = value;
    setPaxDetails(list);
  };

  const resetResults = () => {
    setTxId('');
    setValidationError(false);
    setDepDate(formatDate(getNewDate(TODAY_DATE), API_DATE_FORMAT));
    setToDate(formatDate(getNewDate(TODAY_DATE), API_DATE_FORMAT));
    setArrDate('');
    setNumPax(1);
    setPaxDetails([
      {
        title: '',
        firstname: '',
        lastname: '',
        beneficiarytitle: '',
        beneficiaryname: '',
        beneficiaryfirstname: '',
        beneficiarylastname: '',
        relationshiptoinsured: 'self',
        relationtobeneficiary: '',
        addressline1: '',
        addressline2: '',
        citycode: '',
        emailid: '',
        phonenumber: '',
        countrycode: '',
        majordestination: '',
        passportcountry: '',
        passportno: '',
        pincode: '',
        age: '',
        dob: '',
      },
    ]);
    setTotalInvoice(0);
    setShowFooter(false);
    setAcceptTerms(false);
  };

  const handlePlanSelect = async (plan) => {
    try {
      setSelectedPlan(plan);
      setSelectedResultIndex(plan.resultIndex);
      setSlectedPlanId(plan.traceId);
      setHasDetails(true);
      setSelectedTab('details');
      setDetailsTab(true);
    } catch (error) {
      //
    }
  };
  const handlePalnBreakup = (plan) => {
    selectedPlanForbreakupRef.current = plan;
    setShowBreakupModal(true);
  };

  const handleContinueBooking = async () => {
    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(selectedPlan) ||
        isEmpty(depDate) ||
        isEmpty(toDate) ||
        isEmpty(paxDetail.addressline1) ||
        isEmpty(paxDetail.addressline2) ||
        isEmpty(paxDetail.title) ||
        isEmpty(paxDetail.firstname) ||
        isEmpty(paxDetail.lastname) ||
        isEmpty(paxDetail.beneficiaryfirstname) ||
        isEmpty(paxDetail.beneficiarylastname) ||
        isEmpty(paxDetail.beneficiarytitle) ||
        isEmpty(paxDetail.citycode) ||
        isEmpty(paxDetail.majordestination) ||
        isEmpty(paxDetail.countrycode) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.phonenumber) ||
        isEmpty(paxDetail.emailid) ||
        isEmpty(paxDetail.relationtobeneficiary) ||
        isEmpty(paxDetail.dob)
      ) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
      if (domInt === 'international' && isEmpty(paxDetail.passportno)) {
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });

    if (paymentmode === '') {
      setAlert({
        variant: 'error',
        title: 'Payment Mode',
        description: 'Please select method of payment',
      });
      return false;
    }

    if (paymentmode !== 'cashcard' && selectedPg === 'payu') {
      if (!isPayuPgAccepted) {
        setAlert({
          variant: 'error',
          title: 'Accept Terms',
          description: 'Please Accept terms and conditions of payu',
        });
        return false;
      }
    }

    if (
      paymentmode === 'netbanking' &&
      (selectedPg === 'techprocessv2' ||
        selectedPg === 'techprocessv2_netbanking' ||
        selectedPg === 'payu') &&
      selectedBankForNetBanking === ''
    ) {
      setAlert({
        variant: 'error',
        title: 'Bank Selection',
        description: 'Please select a bank for netbanking',
      });
      return false;
    }

    setIsLoading(true);

    const paxList = paxDetails.map((pax) => pax);
    paxList.forEach((pax) => {
      pax.beneficiaryname = `${pax.beneficiaryfirstname} ${pax.beneficiarylastname}`;
      delete pax.beneficiaryfirstname;
      delete pax.beneficiarylastname;
      delete pax.age;
    });

    const res = await issueTboInsuranceApi(
      paymentmode,
      selectedPlanId,
      selectedResultIndex,
      paxList,
      paymentmode === 'cashcard' ? '' : selectedPg,
      paymentmode === 'netbanking' ? selectedBankForNetBanking : '',
    );
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      if (paymentmode === 'cashcard') {
        setAlert({
          variant: 'success',
          title: 'Insurance',
          description: res.ApiStatus.Message,
        });
        setSuccessTxId(res.ApiStatus.Result);
        setReviewTab(false);
        setResultsTab(false);
        scrollToTop();
        setSelectedTab('confirmation');
        setConfTab(true);
      } else {
        // setAlert({
        //   variant: 'success',
        //   title: 'Insurance',
        //   description: `${res.ApiStatus.Message}....Redirecting to Payment Gateway`,
        // });
        setTimeout(() => {
          window.location.href = `${res.ApiStatus.Result.PgUrl}?txid=${res.ApiStatus.Result.Txid}`;
        }, 2000);
      }
    } else {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: res?.ApiStatus?.Message || 'Failed to book Insurance',
      });
    }
    setIsLoading(false);
    setBookingConfirmationDialogOpen(false);
  };

  const handleSendEmail = async () => {
    setIsLoading(true);
    try {
      let fromEmail = '';
      let fromName = '';
      const res = await getUserDetails(getUserAgentId());
      if (res?.ApiStatus?.Status === 'OK') {
        const { User } = res.ApiStatus.Result;
        fromEmail = User.ContactEmail;
        fromName = `${User.FirstName} ${User.LastName}`;
        const content = document.getElementById(
          'insuranceEmailContent',
        ).innerHTML;
        const response = await emailFlightOptions(
          fromEmail,
          fromName,
          emailToSent,
          content,
          'Your booking details for Travel Insurance',
        );
        if (response && response?.Root?.Status === 'OK') {
          setAlert({
            title: 'Email',
            description: 'Email Sent Successfully',
            variant: 'success',
          });
          setEmailToSent('');
          setShowEmailModal(false);
          setIsLoading(false);
        } else {
          setAlert({
            title: 'Email',
            description: response?.Root?.Message
              ? response?.Root?.Message
              : 'Failed to send email',
            variant: 'error ',
          });
          setEmailToSent('');
          setShowEmailModal(false);
          setIsLoading(false);
        }
      } else {
        setAlert({
          title: 'User Details',
          description: res?.ApiStatus?.Message
            ? res?.ApiStatus?.Message
            : 'Failed to load Agent Details',
          variant: 'error ',
        });
        setEmailToSent('');
        setShowEmailModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      setShowEmailModal(false);
      setIsLoading(false);
      setAlert({
        title: 'User Details',
        description: 'Failed to load Agent Details',
        variant: 'error ',
      });
    }
  };

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setEmailToSent('');
  };

  const handleFetchAvailabilePlans = async () => {
    const ages = paxDetails.map((obj) => obj.age).join(',');
    if (
      isEmpty(depDate) ||
      isEmpty(ages) ||
      isEmpty(domInt) ||
      isEmpty(selectedPlanCovergae)
    ) {
      setValidationError(true);
      return false;
    }
    if (isAfterDate(getNewDate(depDate), getNewDate(toDate))) {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'End Date cannot be before Start Date',
      });
      return false;
    }
    setIsLoading(true);
    const res = await getTboInsurancePlans({
      fromdate: depDate ? formatDate(getNewDate(depDate), API_DATE_FORMAT) : '',
      todate: toDate ? formatDate(getNewDate(toDate), API_DATE_FORMAT) : '',
      numpax: numPax,
      age: ages,
      domint: domInt,
      plancoverage: selectedPlanCovergae,
    });
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      let { Result } = res.ApiStatus;
      Result = Array.isArray(Result) ? Result : [Result];
      setPlanOptions(Result);
      setSelectedTab('results');
      setResultsTab(true);
      setSearchTab(false);
    } else {
      setPlanOptions([]);
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: res?.ApiStatus?.Status || 'Failed to fetch details',
      });
    }
    setIsLoading(false);
  };

  const getAge = (dob) => {
    if (dob !== '') {
      const numYears = differenceInYears(getNewDate(depDate), getNewDate(dob));
      return numYears;
    }
    return '';
  };

  const handlePaxDobSelect = (date, index) => {
    if (isEmpty(depDate)) {
      setAlert({
        variant: 'error',
        title: 'Insurance',
        description: 'Please select Departure Date',
      });
      return false;
    }
    const list = [...paxDetails];
    list[index].dob = date;
    const paxAge = getAge(date);
    list[index].age = paxAge;
    setPaxDetails(list);
  };

  useEffect(() => {
    const fetchAgentDetails = async () => {
      const res = await getUserDetails(getUserAgentId());
      if (res?.ApiStatus?.Status === 'OK') {
        setAgent(res.ApiStatus.Result.User);
      }
    };
    fetchAgentDetails();
  }, []);

  useEffect(() => {
    const fetchPaymentGateways = async () => {
      const userProfile = getObjectFromLS(APP_USER_PROFILE);
      const response = await getPaymentGateway(userProfile?.agentId);
      if (
        response &&
        response.Root &&
        response.Root.Status === 'OK' &&
        response.Root.StatusCode === 200
      ) {
        const availPgs = response?.Root?.Result?.AvailablePaymentGateways;
        if (availPgs !== '' && availPgs !== undefined && availPgs !== null) {
          let list = availPgs.AvailablePaymentGateway;
          list = Array.isArray(list) ? list : [list];
          selectedPaymentGatewayRef.current = list;
          const pgForCreditCard = list.filter(
            (x) => x.PaymentMode.toLowerCase() === 'creditcard',
          );
          setTempPgList(pgForCreditCard);
          if (pgForCreditCard.length > 0) {
            setSelectedPg(pgForCreditCard[0].GatewayName);
          }
          setPaymentGateway(true);
        }
      }
    };
    fetchPaymentGateways();
  }, []);

  useEffect(() => {
    setVisibleOptions(planOptions.slice(0, 30));
  }, [planOptions]);

  const loadMoreHotels = () => {
    const currentCount = visibleOptions.length;
    const newHotels = planOptions.slice(currentCount, currentCount + 30);
    setVisibleOptions((prev) => [...prev, ...newHotels]);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreHotels();
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleOptions]);

  const goToReviewTab = () => {
    let isValid = true;

    paxDetails.forEach((paxDetail) => {
      if (
        isEmpty(paxDetail.addressline1) ||
        isEmpty(paxDetail.addressline2) ||
        isEmpty(paxDetail.title) ||
        isEmpty(paxDetail.firstname) ||
        isEmpty(paxDetail.lastname) ||
        isEmpty(paxDetail.beneficiaryfirstname) ||
        isEmpty(paxDetail.beneficiarylastname) ||
        isEmpty(paxDetail.beneficiarytitle) ||
        isEmpty(paxDetail.citycode) ||
        isEmpty(paxDetail.majordestination) ||
        isEmpty(paxDetail.countrycode) ||
        isEmpty(paxDetail.pincode) ||
        isEmpty(paxDetail.phonenumber) ||
        checkMobileNumber(paxDetail.phonenumber) ||
        isEmpty(paxDetail.emailid) ||
        checkEmailAddress(paxDetail.emailid) ||
        isEmpty(paxDetail.relationtobeneficiary) ||
        isEmpty(paxDetail.dob) ||
        !(paxDetail.beneficiarylastname.trim().length > 2)
      ) {
        isValid = false;
        setValidationError(true);
        scrollToTop();
        return false;
      }

      if (domInt === 'international' && isEmpty(paxDetail.passportno)) {
        isValid = false;
        setValidationError(true);
        scrollToTop();
        return false;
      }
    });
    if (isValid) {
      setSelectedTab('review');
      setDetailsTab(false);
      setReviewTab(true);
      scrollToTop();
    }
  };

  const onBookingConformationDialogClose = async () => {
    setBookingConfirmationDialogOpen(false);
  };

  const handleSetNumPax = (value) => {
    setNumPax(value);
    const newList = new Array(parseInt(value, 10)).fill(0).map(() => ({
      title: '',
      firstname: '',
      lastname: '',
      beneficiarytitle: '',
      beneficiaryname: '',
      beneficiaryfirstname: '',
      beneficiarylastname: '',
      relationshiptoinsured: 'self',
      relationtobeneficiary: '',
      addressline1: '',
      addressline2: '',
      citycode: '',
      emailid: '',
      phonenumber: '',
      countrycode: '',
      majordestination: '',
      passportcountry: '',
      passportno: '',
      pincode: '',
      age: '',
      dob: '',
    }));
    setPaxDetails(newList);
  };

  const handleTabSelection = (tab, isDisableSelection) => {
    if (isDisableSelection) {
      return false;
    }
    setSelectedTab(tab);
  };

  const handleshowCoverageDetails = (plan) => {
    selectedCoverageDetailsRef.current = plan;
    setShowBenifitsPopup(true);
  };
  useEffect(() => {
    if (depDate && toDate) {
      const start = getNewDate(depDate);
      const end = getNewDate(toDate);
      const days = differenceInCalendarDays(end, start);
      setNumDays(days + 1 > 0 ? days + 1 : '');
    } else {
      setNumDays('');
    }
  }, [depDate, toDate]);

  return (
    <div className="visa-page pb-3">
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      <div className="visa-page_container">
        <div className="visa-page_container_header">Insurance</div>
        <div className="visa-page_container_form my-2">
          <div className="align-items-center d-flex flex-wrap gap-2 p-2">
            <AppButton
              btnText="Insurance Search"
              onClick={() => handleTabSelection('search')}
              variant={selectedTab === 'search' ? 'primary' : 'outlined'}
              disabled={!searchTab}
            />
            <AppButton
              btnText="Insurance Results"
              onClick={() => handleTabSelection('results')}
              variant={selectedTab === 'results' ? 'primary' : 'outlined'}
              disabled={!resultsTab}
            />
            <AppButton
              btnText="Passenger Details"
              onClick={() => handleTabSelection('details')}
              variant={selectedTab === 'details' ? 'primary' : 'outlined'}
              disabled={!detailsTab}
            />
            <AppButton
              btnText="Review Insurance"
              onClick={() => handleTabSelection('review')}
              variant={selectedTab === 'review' ? 'primary' : 'outlined'}
              disabled={!reviewTab}
            />
            <AppButton
              btnText="Insurance Confirmation"
              onClick={() => handleTabSelection('confirmation')}
              variant={selectedTab === 'confirmation' ? 'primary' : 'outlined'}
              disabled={!confTab}
            />
          </div>
          <div className="p-2">
            {selectedTab === 'search' && (
              <>
                <Row className="spacing-8">
                  <Col lg={3} md={4} sm={6} xs={12}>
                    <AppSelect
                      required
                      name="planCategory"
                      placeholder=""
                      label="Plan Category"
                      options={[
                        { label: 'Domestic', value: 'domestic' },
                        { label: 'International', value: 'international' },
                      ]}
                      onSelect={(obj) => setDomint(obj?.value)}
                      isClearable={false}
                      selectedValue={domInt}
                      errorText={
                        validationError && 'please select Plan Category'
                      }
                    />
                  </Col>
                  <Col lg={3} md={4} sm={6} xs={12}>
                    <AppSelect
                      required
                      name="planType"
                      placeholder=""
                      label="Plan Type"
                      options={[
                        { label: 'Single Trip', value: 'oneway' },
                        { label: 'AnnualMultiTrip', value: 'roundtrip' },
                      ]}
                      onSelect={(obj) => setPlanType(obj?.value)}
                      isClearable={false}
                      selectedValue={planType}
                      errorText={validationError && 'please select Plan Type'}
                    />
                  </Col>
                  <Col lg={3} md={4} sm={6} xs={12}>
                    <AppSelect
                      required
                      name="planCoverage"
                      placeholder=""
                      label="Plan Coverage"
                      options={planCovergaeOptions}
                      onSelect={(obj) => setSelectedPlanCoverage(obj?.value)}
                      isClearable={false}
                      selectedValue={selectedPlanCovergae}
                      errorText={
                        validationError && 'please select Plan Coverage'
                      }
                    />
                  </Col>
                  <Col lg={3} md={3} sm={4} xs={6}>
                    <AppDatePicker
                      label="Start Date"
                      className="app-date-picker"
                      customClassName={`position-relative  ${
                        validationError && depDate === ''
                          ? 'app-error-text-border'
                          : ''
                      }`}
                      required
                      placeholder=""
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      isCustomeInput={false}
                      minDate={getNewDate(TODAY_DATE)}
                      selectedDate={getNewDate(depDate)}
                      onChange={(date) =>
                        setDepDate(
                          formatDate(getNewDate(date), API_DATE_FORMAT),
                        )
                      }
                      labelClassName="app-date-label"
                    />
                    {validationError && depDate === '' && (
                      <small className="app-error-text">select Dep date</small>
                    )}
                  </Col>
                  <Col lg={3} md={3} sm={4} xs={6}>
                    <AppDatePicker
                      label="End Date"
                      className="app-date-picker"
                      customClassName={`position-relative flight-booking-picker spcaeclass ${
                        validationError && toDate === ''
                          ? 'app-error-text-border'
                          : ''
                      }`}
                      required
                      placeholder=""
                      showMonthDropdown
                      labelClassName="my-bookings-page_date-label"
                      showYearDropdown
                      dropdownMode="select"
                      isCustomeInput={false}
                      minDate={getNewDate(TODAY_DATE)}
                      selectedDate={getNewDate(toDate)}
                      onChange={(date) =>
                        setToDate(formatDate(getNewDate(date), API_DATE_FORMAT))
                      }
                    />
                    {validationError && toDate === '' && (
                      <small className="app-error-text">select end date</small>
                    )}
                  </Col>
                  <Col lg={3} md={3} sm={4} xs={6}>
                    <AppNumberInput
                      required
                      placeholderText=""
                      name="numDays"
                      label="Duration (Days)"
                      value={numDays}
                      disabled
                    />
                  </Col>
                </Row>
                <Row className="spacing-8 mt-2">
                  <Col lg={3} md={4} sm={6} xs={12}>
                    <div>
                      <AppSelect
                        required
                        name="numPax"
                        placeholder=""
                        label="No.of pax"
                        options={paxDropDown}
                        onSelect={(dataObj) => handleSetNumPax(dataObj.value)}
                        isClearable={false}
                        selectedValue={numPax}
                      />
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={12}>
                    {paxDetails.map((pax, index) => (
                      <Row className="spacing-8 mb-2" key={index}>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <AppDatePicker
                            required
                            label={`Date of Birth Pax (${index + 1})`}
                            className="app-date-picker"
                            customClassName={`position-relative  ${
                              validationError && pax.dob === ''
                                ? 'app-error-text-border'
                                : ''
                            }`}
                            placeholder=""
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            isCustomeInput={false}
                            maxDate={getNewDate(TODAY_DATE)}
                            selectedDate={getNewDate(pax.dob)}
                            onChange={(date) =>
                              handlePaxDobSelect(
                                formatDate(getNewDate(date), API_DATE_FORMAT),
                                index,
                              )
                            }
                            labelClassName="app-date-label"
                          />
                          {validationError && isEmpty(pax.dob) && (
                            <small className="app-error-text">
                              select birth date
                            </small>
                          )}
                        </Col>
                        <Col lg={6} md={6} sm={6} xs={12}>
                          <AppNumberInput
                            required
                            placeholderText=""
                            name="age"
                            label={`Age(min 6m, max 70y) (Pax ${index + 1})`}
                            value={pax.age}
                            disabled
                          />
                        </Col>
                      </Row>
                    ))}
                  </Col>
                  <Col
                    lg={3}
                    md={4}
                    sm={6}
                    xs={12}
                    className="d-flex align-items-center fs-14"
                  >
                    <AppLink
                      linkText="Fetch Plans"
                      onClick={handleFetchAvailabilePlans}
                    />
                  </Col>
                </Row>
              </>
            )}
            {selectedTab === 'results' && (
              <Row className="spacing-8">
                {visibleOptions.length > 0 && (
                  <>
                    <div className="d-flex justify-content-between">
                      <AppButton
                        btnText="Modify Search"
                        variant="secondary"
                        className="fs-12"
                        onClick={() => {
                          setSearchTab(true);
                          setResultsTab(false);
                          setSelectedTab('search');
                        }}
                      />

                      <AppButton
                        btnText="Email Selected Quotes"
                        variant="secondary"
                        className="fs-12"
                        onClick={() => setShowEmailModal(true)}
                      />
                    </div>
                    {visibleOptions.map((plan) => {
                      return (
                        <Card key={plan.resultIndex}>
                          <Card.Body>
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <div>
                                  <b>{plan.planName}</b>
                                </div>
                                <div>
                                  <Card.Link
                                    href="#"
                                    onClick={() =>
                                      handleshowCoverageDetails(plan)
                                    }
                                  >
                                    Coverage Details
                                  </Card.Link>
                                </div>
                                <div className="text-center">
                                  <AppCheckBox
                                    labelText="Email"
                                    checked={emailPlans.some(
                                      (selected) =>
                                        selected.resultIndex ===
                                        plan.resultIndex,
                                    )}
                                    onChange={() => handleCheckboxChange(plan)}
                                  />
                                </div>
                              </div>
                              <div className="text-center">
                                {parseInt(numPax, 10) > 1 && (
                                  <div>
                                    <AppLink
                                      linkText="Full Breakup"
                                      className="fs-12"
                                      variant="purple"
                                      onClick={() => {
                                        handlePalnBreakup(plan);
                                      }}
                                    />
                                  </div>
                                )}
                                <div>
                                  <span className="fs-12">Total Price :</span>{' '}
                                  {formatCurrency(plan.grossFare)}
                                </div>
                                <div className="d-flex flex-column align-items-center">
                                  <AppLink
                                    linkText="Choose This"
                                    className="fs-12"
                                    variant="secondary"
                                    onClick={() => {
                                      handlePlanSelect(plan);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </>
                )}
              </Row>
            )}
            {selectedTab === 'details' && (
              <Row>
                <Col lg={9}>
                  {selectedPlan !== '' && (
                    <>
                      {paxDetails.map((pax, index) => (
                        <div className="mt-2" key={index}>
                          <Row className="spacing-16">
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppSelect
                                label="Title"
                                required
                                className="title-select"
                                name="title"
                                id="title"
                                placeholder=""
                                errorText={validationError && 'Select Title'}
                                options={TITLE_OPTIONS}
                                selectedValue={pax.title}
                                isClearable={false}
                                onSelect={(obj) =>
                                  handleUpdatePaxDetails(
                                    'title',
                                    obj.value,
                                    index,
                                  )
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name={`firstname-${index}`}
                                label="First Name"
                                value={pax.firstname || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'firstname',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError && 'please enter first name'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name={`lastname-${index}`}
                                label="Last Name"
                                value={pax.lastname || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'lastname',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError && 'please enter last name'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppDatePicker
                                required
                                label={`Pax ${index + 1} DOB`}
                                className="app-date-picker"
                                customClassName={`position-relative  ${
                                  validationError === ''
                                    ? 'app-error-text-border'
                                    : ''
                                }`}
                                placeholder=""
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                maxDate={getNewDate(TODAY_DATE)}
                                selectedDate={getNewDate(pax.dob) || ''}
                                onChange={(date) =>
                                  handleUpdatePaxDetails(
                                    'dob',
                                    formatDate(
                                      getNewDate(date),
                                      API_DATE_FORMAT,
                                    ),
                                    index,
                                  )
                                }
                                labelClassName="app-date-label"
                                disabled
                              />
                              {validationError && pax.dob === '' && (
                                <small className="app-error-text">
                                  select birth date
                                </small>
                              )}
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name={`address1-${index}`}
                                label="Address 1"
                                value={pax.addressline1 || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'addressline1',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError && 'please enter address1'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name={`address2-${index}`}
                                label="Address 2"
                                value={pax.addressline2 || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'addressline2',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError && 'please enter address2'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name={`cityName-${index}`}
                                label="City"
                                value={pax.citycode || ''}
                                onChange={(e) => {
                                  handleUpdatePaxDetails(
                                    'citycode',
                                    e.target.value,
                                    index,
                                  );
                                }}
                                errorText={
                                  validationError && 'please enter city'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name={`cityName-${index}`}
                                label="Travel Destination"
                                value={pax.majordestination || ''}
                                onChange={(e) => {
                                  handleUpdatePaxDetails(
                                    'majordestination',
                                    e.target.value,
                                    index,
                                  );
                                }}
                                errorText={
                                  validationError &&
                                  'please enter Travel Destination'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppSelect
                                isClearable={false}
                                label="Country"
                                options={COUNTRY_OPTIONS_THREE_CHARS}
                                name={`countrycode-${index}`}
                                selectedValue={pax.countrycode || ''}
                                className="title-select"
                                placeholder=""
                                errorText={
                                  validationError && 'Select Beneficiray Title'
                                }
                                id={`countrycode-${index}`}
                                required
                                onSelect={(obj) => {
                                  handleUpdatePaxDetails(
                                    'passportcountry',
                                    obj.value,
                                    index,
                                  );
                                  handleUpdatePaxDetails(
                                    'countrycode',
                                    obj.value,
                                    index,
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppNumberInput
                                required
                                placeholderText=""
                                name={`pincode-${index}`}
                                label="Pincode"
                                value={pax.pincode || ''}
                                onChange={(e) => {
                                  handleUpdatePaxDetails('pincode', e, index);
                                }}
                                errorText={
                                  validationError && 'please enter pincode'
                                }
                                maxLength={6}
                              />
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={12}>
                              <AppNumberInput
                                required
                                placeholderText=""
                                name="phonenumber"
                                label="Phone Number"
                                value={pax.phonenumber || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'phonenumber',
                                    e,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError && 'please enter phone number'
                                }
                                maxLength={10}
                              />
                              {checkMobileNumber(pax.phonenumber) &&
                                !isEmpty(pax.phonenumber) && (
                                  <small className="app-error-text">
                                    Please enter valid Phone number
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name="emailid"
                                label="Email"
                                value={pax.emailid || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'emailid',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError && 'please enter email'
                                }
                              />
                              {checkEmailAddress(pax.emailid) &&
                                !isEmpty(pax.emailid) && (
                                  <small className="app-error-text">
                                    please enter valid email
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required={domInt === 'international'}
                                placeholderText=""
                                name="passportno"
                                label="Passport Number"
                                value={pax.passportno || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'passportno',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError &&
                                  domInt === 'international' &&
                                  'please enter passport'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppSelect
                                label="Benificiary Title"
                                required
                                className="title-select"
                                name="beneficiarytitle"
                                id={`beneficiarytitle-${index}`}
                                placeholder=""
                                errorText={
                                  validationError && 'Select Beneficiray Title'
                                }
                                options={TITLE_OPTIONS}
                                selectedValue={pax.beneficiarytitle}
                                isClearable={false}
                                onSelect={(obj) =>
                                  handleUpdatePaxDetails(
                                    'beneficiarytitle',
                                    obj.value,
                                    index,
                                  )
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name="beneficiaryfirstname"
                                label="Beneficiary First Name"
                                value={pax.beneficiaryfirstname || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'beneficiaryfirstname',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError &&
                                  'Enter Beneficiray First Name'
                                }
                              />
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppTextInput
                                required
                                placeholderText=""
                                name="beneficiarylastname"
                                label="Beneficiary Last Name"
                                value={pax.beneficiarylastname || ''}
                                onChange={(e) =>
                                  handleUpdatePaxDetails(
                                    'beneficiarylastname',
                                    e.target.value,
                                    index,
                                  )
                                }
                                errorText={
                                  validationError &&
                                  'Enter Beneficiray Last Name'
                                }
                              />
                              {!isEmpty(pax.beneficiarylastname) &&
                                !(
                                  pax.beneficiarylastname.trim().length > 2
                                ) && (
                                  <small className="app-error-text">
                                    Enter atleast 3 characters
                                  </small>
                                )}
                            </Col>
                            <Col lg={3} md={4} sm={6} xs={12}>
                              <AppSelect
                                selectedValue={pax.relationtobeneficiary || ''}
                                options={relationDropDown}
                                isClearable={false}
                                required
                                onSelect={(e) =>
                                  handleUpdatePaxDetails(
                                    'relationtobeneficiary',
                                    e.value,
                                    index,
                                  )
                                }
                                label="Relation"
                                errorText={validationError && 'select relation'}
                              />
                            </Col>
                          </Row>
                          <div className="separator my-2" />
                        </div>
                      ))}
                      <div className="d-flex justify-content-center mt-2">
                        <AppButton
                          btnText="Proceed to Booking Review"
                          variant="outlined"
                          className="px-4 mt-4"
                          onClick={goToReviewTab}
                        />
                      </div>
                    </>
                  )}
                </Col>
                <Col lg={3} md={3} sm={6} xs={12} className="d-flex p-2">
                  <div className="flex-1 rides-container gap-2">
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">Base fare :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.publishedPrice}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">GST :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.commissionEarned}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">Commission :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.cancellationCharge}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">TDS :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.tdsOnCommission}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">Total Invoice :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.offeredPrice}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
            {selectedTab === 'review' && (
              <Row>
                <Col lg={9} md={9} sm={12} xs={12}>
                  <div className="m-3 fs-16 fw-600">{selectedPlan.name}</div>
                  <div>
                    {paxDetails.map((pax, index) => (
                      <Card key={index} className="mt-2">
                        <Card.Body>
                          <Card.Title>Passenger {index + 1}</Card.Title>
                          <Row className="spacing-8">
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <div className="row">
                                <div className="fs-12 col-4">
                                  Passenger Name
                                </div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.title} {pax.firstname} {pax.lastname}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">
                                  Relation To Insured
                                </div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.relationtobeneficiary}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">D.O.B</div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {formatDate(
                                    getNewDate(pax.dob),
                                    DATE_MONTH_YEAR_WITH_HYPHEN,
                                  )}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">
                                  Major Destination
                                </div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.majordestination}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">Email</div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.emailid}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">Passport No</div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.passportno}
                                </div>
                              </div>
                            </Col>
                            <Col lg={6} md={6} sm={6} xs={12}>
                              <div className="row">
                                <div className="fs-12 col-4">
                                  Benificiary Name
                                </div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.beneficiarytitle}{' '}
                                  {pax.beneficiaryfirstname}{' '}
                                  {pax.beneficiarylastname}
                                </div>
                              </div>

                              <div className="row">
                                <div className="fs-12 col-4">Address</div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {`${pax.addressline1} ${pax.addressline2}`}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">City</div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.citycode}
                                </div>
                              </div>
                              <div className="row">
                                <div className="fs-12 col-4">Mobile</div>
                                <div className="col-1">:</div>
                                <div className="fs-14 fw-500 col-7">
                                  {pax.phonenumber}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                  <div>
                    <div className="d-flex justify-content-center mt-2">
                      <AppButton
                        btnText="Proceed"
                        variant="outlined"
                        className="px-4"
                        onClick={handleSubmit}
                      />
                    </div>
                    {showFooter && (
                      <div>
                        <div className="d-flex justify-content-end">
                          <AppLink
                            linkText={showTerms ? 'Hide Terms' : 'Show Terms'}
                            className="fs-12"
                            onClick={() => setShowTerms((prev) => !prev)}
                          />
                        </div>
                        {showTerms && (
                          <>
                            <div className="fs-12">
                              <p>
                                I declare that the information provided in this
                                application is correct.
                              </p>
                              <p>
                                The insured is currently in India and is a
                                resident of India holding a valid Indian
                                passport/Indian work or residence permit.The
                                applicant is above 18 years of age.
                              </p>
                              <p>
                                I also confirm that this policy is not being
                                issued to cover risks directly or indirectly
                                associated with travel in, to, or through
                                Afghanistan, Cuba or Democratic Republic of
                                Congo. I/ We hereby declare, on my behalf and on
                                behalf of all persons proposed to be insured
                                that the above statements, answers and/or
                                particulars given by me are true and complete in
                                all respects to the best of my knowledge and
                                that I/We am/ are authorized to propose on
                                behalf of these other persons.
                              </p>
                              <p>
                                I/ We understand that the information provided
                                by me will form the basis of insurance policy,
                                is subject to the Board approved underwriting
                                policy of the Insurance company and that the
                                policy will come into force only after full
                                receipt of the premium chargeable.
                              </p>
                              <p>
                                I/ We further declare that I/We will notify in
                                writing any change occurring in the occupation
                                or general health of the life to be insured/
                                proposer after the proposal has been submitted
                                but before communication of the risk acceptance
                                by the company.
                              </p>
                              <p>
                                I/We declare and consent to the company seeking
                                medical information from any doctor or from a
                                hospital who at anytime has attended on the life
                                to be insured/ proposer or from any past or
                                present employer concerning anything which
                                affects the physical and mental health of the
                                life to be assured/proposer and seeking
                                information from any insurance company to which
                                an application for insurance on the life to be
                                assured/ proposer has been made for the purpose
                                of underwriting the proposal and/or claim
                                settlement.
                              </p>
                              <p>
                                I/ We authorize the company to share information
                                pertaining to my proposal including the medical
                                records for the sole purpose of proposal
                                underwriting and/or claims settlement and with
                                any Governmental and/or Regulatory Authority.
                              </p>
                            </div>
                            <div className="mt-2 fs-12">
                              <p>AML guidelines:</p>
                              <p>
                                1. I/We hereby confirm that all premiums have
                                been/will be paid from bonafide sources and no
                                premiums have been/will be paid out of proceeds
                                of crime related to any of the offence listed in
                                preventions of Money Laundering Act, 2002.
                              </p>
                              <p>
                                2. I understand that the Company has the right
                                to call for documents to establish sources of
                                funds.
                              </p>
                              <p>
                                3. The insurance Company has right to cancel the
                                insurance contract in case I am/have been found
                                guilty by any competent court of law under any
                                of the statutes,directly or indirectly governing
                                the prevention of money laundering in India.
                              </p>
                              <p>
                                I have read and understood the above mention
                                Terms & Conditions.
                              </p>
                              <p className="my-3">
                                Section 41 of Insurance Act 1938 (Prohibition of
                                rebates): Statutory warning - 1. &quot;No person
                                shall allow or offer to allow either directly or
                                indirectly as an inducement to any person to
                                take out or renew or continue an insurance in
                                respect of any kind of risk relating to lives or
                                property in India, any rebate of the whole or
                                part of the commission payable or any rebate of
                                premium shown on the policy, nor shall any
                                person taking out or renewing or continuing a
                                policy accept any rebate, except such rebate as
                                may be allowed in accordance with the published
                                prospectus or tables of the insurers&quot;. 2.
                                If any person fails to comply with sub
                                regulation (1) above, he shall be liable to
                                payment of a fine which may extend to rupees
                                five hundred.
                              </p>
                              <p>64VB:</p>
                              <p className="mb-3">
                                Commencement of risk cover under the policy is
                                subject to receipt and realisation of payable
                                premium by Tata AIG General Insurance Company
                                Limited.
                              </p>
                              <p>General Exclusions:</p>
                              <p>
                                1. Insured Person is traveling against the
                                advice of a Physician; or is travelling for the
                                purpose of obtaining treatment.
                              </p>
                              <p>
                                2. Any Pre-existing Condition or any
                                complication arising from it; or
                              </p>
                              <p>
                                3. Suicide, attempted suicide (whether sane or
                                insane) or intentionally self inflicted Injury
                                or Illness, or sexually transmitted conditions,
                                mental or nervous disorder, anxiety, stress or
                                depression, Acquired Immune Deficiency Syndrome
                                (AIDS), Human Immune deficiency Virus (HIV)
                                infection; or
                              </p>
                              <p>
                                4. Serving in any branch of the Military or
                                Armed Forces of any country, whether in peace or
                                War,
                              </p>
                              <p>
                                5. Being under the influence of drugs, alcohol,
                                or other intoxicants or hallucinogens
                              </p>
                              <p>
                                6. Participation in an actual or attempted
                                felony, riot, crime, misdemeanor, or civil
                                commotion; or
                              </p>
                              <p>
                                7. Operating or learning to operate any
                                aircraft, or performing duties as a member of
                                the crew on any aircraft or Scheduled Airline;
                                or
                              </p>
                              <p>
                                8. Any loss arising out of War, civil war,
                                invasion, insurrection, revolution, act of
                                foreign enemy,
                              </p>
                              <p>
                                9. Any loss, damage cost or expense of
                                whatsoever nature directly or indirectly caused
                                by, resulting from or in connection with any act
                                of terrorism.
                              </p>
                              <p>
                                10. Any loss arising out of the intentional use
                                of military force to intercept, prevent, or
                                mitigate any known or suspected Act of
                                Terrorism;or
                              </p>
                              <p>
                                11. The use, release or escape of nuclear
                                materials that directly or indirectly results in
                                nuclear reaction or radiationor radioactive
                                contamination;
                              </p>
                              <p>
                                12. The radioactive, toxic, explosive or other
                                dangerous properties of any explosive nuclear
                                equipment or any part of that equipment; or
                              </p>
                              <p>
                                13. Performance of manual work for employment or
                                any other potentially dangerous occupation; or
                              </p>
                              <p>
                                14. Congenital anomalies or any complications or
                                conditions arisingtherefrom; or
                              </p>
                              <p>
                                15. Osteoporosis (porosity and brittleness of
                                the bones due to loss of protein from the bones
                                matrix) or pathological fracture (any fracture
                                in an area where pre-existing Disease has caused
                                the weakening of the bone)
                              </p>
                              <p>
                                16. Participation in winter sports,
                                skydiving/parachuting, hang gliding, bungee
                                jumping, scuba diving, mountain climbing
                              </p>
                              <p>
                                17. Pregnancy and all related conditions, This
                                however does not include ectopic pregnancy
                                proved by diagnostic means and is certified to
                                be life threatening by the Physician; or
                              </p>
                              <p>
                                18. For any loss of which a contributing cause
                                was your actual or attempted commission of, or
                                willful participation in, an illegal act or any
                                violation or attempted violation of the law or
                                Your resistance to arrest;
                              </p>
                              <p>
                                19. Any loss, injury, damage or legal liability
                                arising directly or indirectly from: Travel in,
                                to, or through Afghanistan, Cuba or Democratic
                                Republic of Congo; or
                              </p>
                              <p>
                                20. Any loss, injury, damage or legal sustained
                                directly or indirectly by: Any terrorist or
                                member of a terrorist organisation, narcotics
                                trafficker, or purveyor of nuclear, chemical or
                                biological weapons.
                              </p>
                              <p className="mt-2">
                                For complete list of detailed exclusion, please
                                refer policy wordings
                              </p>
                              <p>
                                I have read and understood the policy wordings
                              </p>
                            </div>
                          </>
                        )}

                        <div className="separator" />
                        <div className="">
                          <div className="flight-booking-page_title">
                            Payment options
                          </div>
                          <div className="d-flex cursor-pointer">
                            {getEligibilityForPaymentMode('wallet') && (
                              <div
                                role="button"
                                tabIndex={0}
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentmode === 'cashcard'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('cashcard')}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    updatePaymentMode('cashcard');
                                  }
                                }}
                              >
                                <CiWallet />
                                Wallet
                              </div>
                            )}
                            {getEligibilityForPaymentMode('creditcard') && (
                              <div
                                role="button"
                                tabIndex={0}
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentmode === 'creditcard'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('creditcard')}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    updatePaymentMode('creditcard');
                                  }
                                }}
                              >
                                <MdOutlineCreditCard /> CreditCard
                              </div>
                            )}
                            {getEligibilityForPaymentMode('debitcard') && (
                              <div
                                role="button"
                                tabIndex={0}
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentmode === 'debitcard'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('debitcard')}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    updatePaymentMode('debitcard');
                                  }
                                }}
                              >
                                <MdOutlineCreditCard /> DebitCard
                              </div>
                            )}
                            {getEligibilityForPaymentMode('netbanking') && (
                              <div
                                role="button"
                                tabIndex={0}
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentmode === 'netbanking'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('netbanking')}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    updatePaymentMode('netbanking');
                                  }
                                }}
                              >
                                <CiBank />
                                Netbanking
                              </div>
                            )}
                            {getEligibilityForPaymentMode('upi') && (
                              <div
                                role="button"
                                tabIndex={0}
                                className={`flex-1 p-2 d-flex gap-1 fs-14 align-items-center justify-content-center fw-500 ${
                                  paymentmode === 'upi'
                                    ? 'primary-color'
                                    : 'grey-color'
                                }`}
                                onClick={() => updatePaymentMode('upi')}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    updatePaymentMode('upi');
                                  }
                                }}
                              >
                                <CiBank />
                                UPI
                              </div>
                            )}
                          </div>

                          {PaymentGateway === true &&
                            tempPgList.length > 0 &&
                            paymentmode !== 'cashcard' &&
                            paymentmode !== '' && (
                              <div className="d-flex justify-content-start gap-4">
                                <div className="flight-booking-page_title">
                                  Payment Gateway
                                </div>
                                {tempPgList.map((pgdisp, index) => (
                                  <AppRadioInput
                                    key={index}
                                    id={pgdisp.GatewayName}
                                    name="paymentGateway"
                                    labelText={
                                      pgdisp.GatewayName === 'techprocessv2'
                                        ? 'Worldline'
                                        : pgdisp.GatewayName
                                    }
                                    value={pgdisp.GatewayName}
                                    onChange={() =>
                                      handlePgSelection(pgdisp.GatewayName)
                                    }
                                    checked={selectedPg === pgdisp.GatewayName}
                                  />
                                ))}
                              </div>
                            )}
                          {paymentmode === 'netbanking' &&
                            paymentmode !== '' &&
                            isEmpty(
                              getValueFromAppConfig('disableDropDown'),
                            ) && (
                              <div className="d-flex justify-content-start p-3">
                                <AppSelect
                                  name="selected_bank"
                                  id="selected_bank"
                                  label="Select Bank"
                                  placeholder=""
                                  required={
                                    selectedPg === 'techprocessv2' ||
                                    selectedPg === 'techprocessv2_netbanking' ||
                                    selectedPg === 'payu'
                                  }
                                  selectWidth="300px"
                                  isClearable={false}
                                  options={NET_BANKING_OPTIONS_LIVE}
                                  selectedValue={selectedBankForNetBanking}
                                  onSelect={(dataObj) =>
                                    setSelectedBankForNetBanking(dataObj.value)
                                  }
                                  errorText={
                                    validationError &&
                                    (selectedPg === 'techprocessv2' ||
                                      selectedPg ===
                                        'techprocessv2_netbanking' ||
                                      selectedPg === 'payu') &&
                                    'select bank'
                                  }
                                />
                              </div>
                            )}

                          {paymentmode !== '' &&
                            paymentmode !== 'cashcard' &&
                            selectedPg === 'payu' && (
                              <div className="px-3 d-flex flex-column">
                                <p className="mb-2 px-4 fs-14">
                                  Accept Terms and Conditions of <b>payu</b>
                                </p>
                                <AppCheckBox
                                  labelText={`${agent.Company} certifies that the Credit/Debit Card/Net Banking Account being used for this transaction belongs to ${agent.Company} or an authorized employee of ${agent.Company}. In particular, this Card/Net Banking Account does not belong to a customer or passenger.`}
                                  id="payuPgAccepted"
                                  name="payuPgAccepted"
                                  radioClassName="w-25px"
                                  checked={isPayuPgAccepted}
                                  labelClassName="fs-12"
                                  onChange={() =>
                                    setIsPayuPgAccepted((prev) => !prev)
                                  }
                                />
                                <div className="d-flex align-items-center fs-12 ps-sm-4 my-2 ps-2 gap-1">
                                  <img
                                    src="/images/others/payu.jpg"
                                    alt=""
                                    height="20px"
                                  />
                                  <img
                                    src="/images/others/visa_mastercard.gif"
                                    alt=""
                                    height="20px"
                                  />
                                  <span>
                                    (Only Personal Credit Cards @ 1.77% | Rupay
                                    Debit Card allowed @0.25%)
                                  </span>
                                </div>
                              </div>
                            )}
                        </div>
                        <div className="d-flex flex-column gap-2 align-items-center">
                          <AppCheckBox
                            labelText="I agree the Terms & Conditions"
                            id="acceptTerms"
                            name="acceptTerms"
                            checked={acceptTerms}
                            labelClassName="fs-12"
                            onChange={() => setAcceptTerms((prev) => !prev)}
                          />
                          <AppButton
                            btnText="Continue Booking"
                            variant="primary"
                            disabled={!acceptTerms}
                            onClick={handleContinueBooking}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
                <Col lg={3} md={3} sm={12} xs={12} className="d-flex p-2">
                  <div className="flex-1 rides-container gap-2">
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">Base fare :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.publishedPrice}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">GST :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.commissionEarned}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">Commission :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.cancellationCharge}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">TDS :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.tdsOnCommission}
                      </div>
                    </div>
                    <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                      <div className="fs-12">Total Invoice :</div>
                      <div className="fs-14 fw-500">
                        {selectedPlan.offeredPrice}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
            {selectedTab === 'confirmation' && (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="fs-18 fw-500 green-color">
                    Insurance Booking Successful
                  </div>

                  <AppButton
                    btnText="Go To Voucher"
                    onClick={() => {
                      window.location.href = `/insurance/voucher/${successTxId}`;
                    }}
                  />
                </div>

                <div>
                  {paxDetails.map((pax, index) => (
                    <Card key={index} className="mt-2">
                      <Card.Body>
                        <Card.Title>Passenger {index + 1}</Card.Title>
                        <Row className="spacing-8">
                          <Col lg={6} md={6} sm={6} xs={12}>
                            <div className="row">
                              <div className="fs-12 col-4">Passenger Name</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.title} {pax.firstname} {pax.lastname}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">
                                Relation To Insured
                              </div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.relationtobeneficiary}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">D.O.B</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {formatDate(
                                  getNewDate(pax.dob),
                                  DATE_MONTH_YEAR_WITH_HYPHEN,
                                )}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">
                                Major Destination
                              </div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.majordestination}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">Email</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.emailid}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">Passport No</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.passportno}
                              </div>
                            </div>
                          </Col>
                          <Col lg={6} md={6} sm={6} xs={12}>
                            <div className="row">
                              <div className="fs-12 col-4">
                                Benificiary Name
                              </div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.beneficiarytitle}{' '}
                                {pax.beneficiaryfirstname}{' '}
                                {pax.beneficiarylastname}
                              </div>
                            </div>

                            <div className="row">
                              <div className="fs-12 col-4">Address</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {`${pax.addressline1} ${pax.addressline2}`}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">City</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.citycode}
                              </div>
                            </div>
                            <div className="row">
                              <div className="fs-12 col-4">Mobile</div>
                              <div className="col-1">:</div>
                              <div className="fs-14 fw-500 col-7">
                                {pax.phonenumber}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {showBenifitsPopup && (
        <AppModal
          modalTitle="Coverage Details"
          showFooter={false}
          showCloseButton
          className="sales-rep-details fs-14"
          onModalClose={() => {
            setShowBenifitsPopup(false);
            selectedCoverageDetailsRef.current = undefined;
          }}
        >
          {selectedCoverageDetailsRef.current?.coverageDetails?.length > 0 ? (
            <div className="d-flex flex-column">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Coverage</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCoverageDetailsRef.current?.coverageDetails.map(
                    (benifit, index) => (
                      <tr key={index}>
                        <td>{benifit.Coverage}</td>
                        <td>
                          {benifit.SumCurrency} {benifit.SumInsured}
                        </td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No Coverage Details Found</div>
          )}
        </AppModal>
      )}
      {showBreakupModal && (
        <AppModal
          modalTitle="Premium Amount Breakup"
          showFooter={false}
          showCloseButton
          className="sales-rep-details fs-14"
          onModalClose={() => setShowBreakupModal(false)}
        >
          {selectedPlanForbreakupRef.current ? (
            <div className="d-flex flex-column">
              <p>
                Plan Name:{' '}
                <b>{selectedPlanForbreakupRef.current.paxSearchInfo[0].name}</b>
              </p>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Age</th>
                    <th>Premium Amount</th>
                    <th>Day Limit</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedPlanForbreakupRef.current.paxSearchInfo.map(
                    (pax, index) => (
                      <tr key={index}>
                        <td>{pax.age}</td>
                        <td>{pax.premium}</td>
                        <td>{pax.daylimit}</td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No Benifits Found</div>
          )}
        </AppModal>
      )}
      {showEmailModal && (
        <AppModal
          modalTitle="Share Plan Details"
          showFooter={false}
          showCloseButton
          className="sales-rep-details fs-14"
          onModalClose={handleCloseEmailModal}
        >
          <div className="d-flex gap-2 align-items-center">
            <div className="flex-1">
              <AppTextInput
                label="Email"
                value={emailToSent}
                onChange={(e) => setEmailToSent(e.target.value)}
              />
            </div>
            <AppButton btnText="Send Email" onClick={handleSendEmail} />
          </div>
        </AppModal>
      )}

      {isBookingConfirmationDialogOpen && (
        <AppModal
          modalTitle="Booking Confirmation"
          showCloseButton
          showFooter={false}
          size="xl"
          onModalClose={() => onBookingConformationDialogClose(false)}
        >
          <section className="booking-confirmation-dialog">
            <section className="p-3 booking-confirmation-border-bottom">
              <section className="p-3 booking-confirmation-border-bottom">
                <div className="pb-2">
                  <span className="booking-dialog-header">Fare Breakup</span>
                </div>
                <Row className="spacing-16">
                  <Col lg={12}>
                    <div className="flex-1 rides-container gap-2">
                      <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                        <div className="fs-12">Base fare :</div>
                        <div className="fs-14 fw-500">
                          {selectedPlan.publishedPrice}
                        </div>
                      </div>
                      <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                        <div className="fs-12">GST :</div>
                        <div className="fs-14 fw-500">
                          {selectedPlan.commissionEarned}
                        </div>
                      </div>
                      <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                        <div className="fs-12">Commission :</div>
                        <div className="fs-14 fw-500">
                          {selectedPlan.cancellationCharge}
                        </div>
                      </div>
                      <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                        <div className="fs-12">TDS :</div>
                        <div className="fs-14 fw-500">
                          {selectedPlan.tdsOnCommission}
                        </div>
                      </div>
                      <div className="mt-2 d-flex align-items-center gap-2 flex-wrap justify-content-between">
                        <div className="fs-12">Total Invoice :</div>
                        <div className="fs-14 fw-500">
                          {selectedPlan.offeredPrice}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </section>
              <section
                className="d-flex justify-content-center p-3"
                style={{ paddingTop: 32 }}
              >
                <AppButton
                  variant="primary"
                  btnText="Book"
                  onClick={handleContinueBooking}
                  className="width-150"
                />
                <AppButton
                  variant="outlined"
                  btnText="Close"
                  onClick={() => onBookingConformationDialogClose(false)}
                  className="width-150 ms-3"
                />
              </section>
            </section>
          </section>
        </AppModal>
      )}

      <div id="insuranceEmailContent" className="d-none">
        <div
          style={{
            border: '1px solid #ccc',
            padding: '10px',
            margin: '10px',
          }}
        >
          <p
            style={{
              fontWeight: '600',
            }}
          >
            Dear Partner,
          </p>
          <p>As per your request, we are forwarding Travel insurance policy</p>
          <div
            style={{
              backgroundColor: '#0770e4',
              color: '#fff',
              border: '1px solid #0770e4',
            }}
          >
            <table style={{ width: '100%' }}>
              <thead>
                {emailPlans.length > 0 &&
                  emailPlans.map((plan, index) => (
                    <tr key={index}>
                      <th>{plan.planName}</th>
                      <th style={{ textAlign: 'right' }}>
                        Price: {plan.currency} {plan.grossFare}
                      </th>
                    </tr>
                  ))}
              </thead>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TboInsurance;
